export default [
    {
        type: 'text',
        name:'depotName',
        label: 'Business Site Name',
        validation: 'required',
        autocomplete: 'off'
    }
]